export const TAGS = {
  PROFILE_ACCOUNT_LIST: 'accountList',
  PROFILE_AVAILABLE_ACCOUNTS_LIST: 'availableAccountList',
};
